import React, { useState } from 'react';

import arrow from '../../assets/icons/arrowdown.svg';
import arrowWhite from '../../assets/icons/arrowdown-white.svg';

const Accordion = (props) => {
    const [buttonClicked, setButtonClicked] = useState(false);
    const [arrowDirection, setArrowDirection] = useState(false);
    return (
        <div className={`accordion`}>
            <div onClick={() => { setButtonClicked(true); setArrowDirection(!arrowDirection)}} className={`accordion__container ${props.classes ? props.classes : ''}`}>
                <h2 className="accordion__title">
                    {props.title}
                </h2>
                {props.isExpandable && <img src={props.arrowWhite ? arrowWhite : arrow} alt="arrow" className={`accordion__arrow accordion__arrow${buttonClicked ? (arrowDirection  ? '--down' : '--up') : ''}`} />}
            </div>
            <div className={`accordion__content${!props.isExpandable ? '--expanded' : ''} accordion__content${buttonClicked && props.isExpandable ? (arrowDirection  ? '--down' : '--up') : ''}`}>
                {React.cloneElement(props.children ? props.children : <React.Fragment />, props)}
            </div>
        </div>
    );
}

export default Accordion;